import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { getRandomInt, randomString, getCDate, check, sleep, genKey } from "@/customFunction";
const headers = { Accept: "application/json" };
import router from "../router";
import customAxios from "../axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    site: {
      avatar:
        "https://firebasestorage.googleapis.com/v0/b/cip-generic.appspot.com/o/default-user.png?alt=media&token=82389d15-0419-4d2c-8b5e-5fe3e18c3ca7",
      language: "en",
      logo: "/aramcco.png", // "/mcit_okrtool/mcit-logo.png",
      name: "ARAMCCO GERMANY | CRM | ERP",
      theme: {
        light: {
          accent: "#102944",
          error: "#FF5252",
          info: "#2196F3",
          primary: "#104b91",
          secondary: "#950e0e",
          success: "#4CAF50",
          warning: "#FFC107"
        }
      }
    },
    access_token: null,
    last_click: null,
    lock_: null,
    unlock_: null,
    i18n: {
      en: {
        oldTemplates: "Old templates",
        templateType: "Template type",
        domainsuppressions: "Domains suppressions",
        domain_suppressions: "Domain suppressions",
        include_candidates_db: "Include Candidates DB",
        sendTest: "Send Test",
        Draft: "Draft",
        alternative_phone: "Alternative Phone",
        call_back_date: "Call Back Date",
        leadCounters: "Lead counters",

        profile: "Profile",

        not_set: "Not set",
        recognation: "Recognation",

        recognition_documents_ready: "recognition documents ready",
        recognition_documents_ready_date: "recognition documents ready date",
        recognition_documents_submitted: "recognition documents submitted",
        recognition_documents_submitted_date: "recognition documents submitted date",
        recognition_documents_reviewed: "recognition documents reviewed",
        recognition_documents_reviewed_date: "recognition documents reviewed date",
        recognition_documents_sent_dhl: "recognition documents sent dhl",
        recognition_documents_sent_dhl_date: "recognition documents sent dhl date",
        recognition_documents_recieved_dhl: "recognition documents recieved dhl",
        recognition_documents_recieved_dhl_date: "recognition documents recieved dhl date",
        recognition_documents_submitted_to_authority:
          "recognition documents submitted to authority",
        recognition_documents_submitted_to_authority_date:
          "recognition documents submitted to authority date",
        recognition_documents_result: "recognition documents result",
        recognition_documents_result_date: "recognition documents result date",

        from_date: "From date",
        to_date: "To date",

        reference: "Reference",
        never_logged_in: "Never logged in",
        application_suspended: "Application suspended",
        last_login_at: "Last login",
        "evaluation-appointment-settings": "Evaluation appointment settings",
        evaluationAppointmentSettings: "Evaluation appointment settings",
        domainSetup: "Domain setup",
        "domain-setup": "Domain setup",
        valid_start: "Valid start",
        valid_end: "Valid end",
        first_fees: "First fees",
        first_fees_currency: "First fees currency",
        second_fees: "Second fees",
        second_fees_currency: "Second fees currency",

        visa_granted_document: "Visa granted document",
        accelerated_procedure_result_document: "Accelerated procedure result document",
        ba_result_document: "Ba result document",
        cloudflare_status: "Cloudflare status",
        aws_status: "AWS status",
        not_ready: "Not ready",
        third_fees: "third_fees",
        third_fees_currency: "third_fees_currency",
        fourth_fees: "fourth_fees",
        fourth_fees_currency: "fourth_fees_currency",
        fifth_fees: "fifth_fees",
        fifth_fees_currency: "fifth_fees_currency",
        sixth_fees: "sixth_fees",
        sixth_fees_currency: "sixth_fees_currency",
        seventh_fees: "seventh_fees",
        seventh_fees_currency: "seventh_fees_currency",
        eighth_fees: "eighth_fees",
        eighth_fees_currency: "eighth_fees_currency",
        nineth_fees: "nineth_fees",
        nineth_fees_currency: "nineth_fees_currency",
        tenth_fees: "tenth_fees",
        tenth_fees_currency: "tenth_fees_currency",
        contracts: "Contracts",
        kick_candidate: "Kick candidate",
        document_type: "Document type",
        languages: "Languages",
        visa: "Visa",
        "database-sectors": "database sectors",
        request: "request",
        candidateSubmissionRequest: "Candidate submission request",
        candidateInterviews: "Candidate interviews",
        created_at: "Created at",
        candidateEvaluations: "Candidate evaluations",
        candidateUpdates: "Candidate updates",
        employee_name: "employee_name",
        appointment_time: "Appointment time",
        submission_requests: "Submission requests",
        interview_accepted: "Accepted",
        interview_rejected: "Rejected",
        ammount: "Ammount",
        currency: "Currency",
        done: "Done",
        approved: "Approved",
        deadline: "Deadline",
        transaction: "Transaction",
        transaction: "Transactions",
        calls: "Calls",
        call: "Call",
        documents: "Documents",
        document: "Document",
        update_value: "Update value",
        update_field: "Update field",
        accepted: "Accepted",
        link: "Link",
        information: "Information",
        application: "Application",
        result: "Result",

        interview: "Interview",
        appointment: "Appointment",
        evaluation: "Evaluation",

        visas_access: "Visa access",
        visa_appointment: "Visa appointment",
        visa_application_ready: "Visa application ready",
        visa_application_submitted: "Visa application submitted",
        visa_granted: "Visa granted",
        visa_granted_document_id: "Visa granted document id",

        accelerated_procedure_documents_ready: "Accelerated procedure documents ready",
        accelerated_procedure_result: "Accelerated procedure result",
        accelerated_procedure_result_document_id: "Accelerated procedure result document id",
        accelerated_procedure_submitted: "Accelerated procedure submitted",
        ba_documents_ready: "Ba documents ready",
        ba_result: "Ba result",
        ba_result_document_id: "Ba result document id",
        ba_submitted: "Ba submitted",
        airline_ticket_document: "Airline ticket document",
        airline_ticket_document_id: "Airline ticket document id",
        booked_airline_ticket: "Booked airline ticket",

        b_2_certificate_submited: "B2 certificate submited",
        b_1_certificate_submited: "B1 certificate submited",

        b_2_certificate: "B2 certificate",
        b_2_passed: "B2 passed",
        b_2_finished: "B2 finished",
        b_2_started: "B2 started",

        b_1_certificate: "B1 certificate",
        b_1_passed: "B1 passed",
        b_1_finished: "B1 finished",
        b_1_started: "B1 started",

        a_2_certificate: "A2 certificate",
        a_2_passed: "A2 passed",
        a_2_finished: "A2 finished",
        a_2_started: "A2 started",

        a_1_passed: "A1 passed",
        a_1_finished: "A1 finished",
        a_1_started: "A1 started",
        language_started: "Language started",

        appointment_details: "Appointment details",
        today: "Today",
        day: "Day",
        week: "Wekk",
        month: "Month",
        appointments_calendar: "Appointment calendar",
        appointmentsCalendar: "Appointment calendar",

        // Transactions
        transaction_approved: "Approved",
        transaction_done: "Paid",
        transaction_deadline: "Transaction deadline",
        transaction_amount: "Amount",

        // Timeline
        last_update: `Last update`,
        rejected: `Rejected`,
        updated_field: `Updated field`,
        updated_value: `Updated value`,
        updated_status: `Updated status`,
        call_by: "Call by",

        employee_name: "Employee name",
        status: "status",
        answered: "Answered",
        unanswered: "Unanswered",
        timeline: "Timeline",
        submit: "Submit",
        submissionRequests: "Submission requests",
        candidate_profile: `candidate_profile`,
        phone: `phone`,
        phone_alternative: `phone_alternative`,
        country_id: `country_id`,
        program_id: `program_id`,
        aramcco_code: `aramcco_code`,
        registration_date: `registration_date`,
        birth_date: `birth_date`,
        id_number: `id_number`,
        last_pass_number: `last_pass_number`,
        language_level_id: `language_level_id`,
        birth_place: `birth_place`,
        gender: `gender`,

        submited_review: `Review submitted`,
        request_title: "Request title",
        submited: "submited",
        already_submited: `Already submited`,

        ok: "ok",
        copy: "Copy",
        open: "Open",
        interview_status: "Status",
        interview_accepted: "Accepted",
        interview_pending: "Pending",
        interview_link: "Link",
        interview_information: "Information",
        interview_application: "Application",
        past_interviews: "Interviews",
        pastInterviews: "Interviews",
        yes: "Yes",
        no: "No",
        was_present: "Was he present ?",
        attended: "Attended",
        absent: "Absent",
        evaluation_result: "Result",
        evaluation_appointment: "Appointment",
        evaluation_update_date: "Update date",
        evaluation_note: "Note",
        past_evaluations: "Evaluations",
        pastEvaluations: "Evaluations",
        evaluations: "Evaluations",

        yes: "Yes",
        no: "No",
        copy: "Copy",
        open: "Open",
        cv_url: "Cv url",
        portrait_url: "Portrait url",
        uuid: "Uuid",
        ready: "Ready",
        contract: "Contract",
        contract_date: "Contract date",

        "ready-candidates": "Ready candidates",
        readyCandidates: "Ready candidates",

        print_candidate: "Print candidate",
        print: "Print",
        male: "Male",
        female: "Female",
        birth_place: "Birth place",
        gender: "Gender",

        //// nav
        whatsappofficialsettings: `Official WA Settings`,
        leadsReport: `Leads Report`,
        health: `Health`,
        ads: `Ads`,
        from: `From`,
        to: `To`,
        duration: `Duration`,
        "online-candidates": `Online Candidates`,
        "online-appointments": `Online Appointments`,
        "online-seminars": `Online Seminars`,
        "online-appointments-settings": `Online Appointments Settings`,
        "online-seminars-settings": `Online Seminars Settings`,
        online: `Online`,
        onlineCandidates: `Candidates`,
        onlineAppointments: `Appointments`,
        onlineSeminars: `Seminars`,
        onlineAppointmentsSettings: `Appointments Settings`,
        onlineSeminarsSettings: `Seminars Settings`,
        zoom: `Zoom`,
        limitRegister: `Number Limit`,
        candidates: `Candidates`,
        whatsapplog: `Log`,
        advantages: `Advantages`,
        conditions_to_check: `Conditions`,
        emailSoftware: `Emails System`,
        campaigns: `Campaigns`,
        campaign: `Campaign`,
        lists: `Lists`,
        list: `List`,
        templates: `Templates`,
        template: `Template`,
        accountCreated: `Account Created, Contact Admin To Grant Access`,
        sent: `Sent`,
        opened: `Opened`,
        clicked: `Clicked`,
        lastChange: `Last Change`,
        agent: `Employee`,
        access: `Access`,
        userRole: `User Role`,
        user: `User`,
        users: `Users`,
        admin: `Admin`,
        superadmin: `Super Admin`,
        userEmail: `User Email`,
        userName: `Username`,
        close: `Close`,
        position: `Position`,
        submitBtn: `Save`,
        reload: `reload`,
        subject: `Subject`,
        fromName: `From Name`,
        fromEmail: `From Email`,
        replyTo: `Reply To`,
        lastUpdated: `Last Updated`,
        sendingActive: `Sending...`,
        inDraft: `Draft`,
        alreadySent: `Sent`,
        sendIconTooltip: `Send Now`,
        scheduleIconTooltip: `Send Later`,
        valid_email: `Please enter a valid Email`,
        leads: `Leads`,
        subscribers: `Subscribers`,
        suppressions: `Supression`,
        offices: `Offices`,
        create: `Create`,
        areYouSureOfDelete: `Are you sure you want to delete |item|, this cant be restored!`,
        deleteBtn: `Delete`,
        interviews: `interviews`,
        automation: `Automation`,
        delay: `Delay`,
        delay_unit: `Delay Unit`,
        company: `Company`,
        time: `Time`,
        day: `Day`,
        days: `Days`,
        company_address: `Company address`,
        conditions: `Conditions`,
        google_map: `Google map`,
        day_language: `Day language`,
        promo_text: `Promo text`,
        language: `Language`,
        programs: `Programs`,
        phones: `Phones`,
        subject: `Subject`,
        limit: `Count To Send`,
        program: `Program`,
        emails: `Emails`,
        delivered: `Delivered`,
        opened: `Opened`,
        clicked: `Clicked`,
        bounced: `Bounced`,
        pleaseEnterPin: `Please Enter Pin`,
        pin: `Pin`,
        continue: `Continue`,
        edit: `Edit`,
        country: `Country`,
        phone: `Phone`,
        status: `Status`,
        note: `Note`,
        user: `Employee`,
        program_name: `program`,
        bundesland_name: `state`,
        sector_name: `sector`,
        country_name: `country`,
        user_name: `employee`,
        status_name: `status`,
        source: `Source`,
        settings: `Settings`,
        countries: `Countries`,
        statuses: `Statuses`,
        AddItem: `Add item`,
        french: `French`,
        duplicate: `Duplicate`,
        userCountries: `User countries`,
        userPrograms: `User Programs`,
        userRoles: `User Roles`,
        hq: `Head Quarter`,
        branchManager: `Branch Manager`,
        programManager: `Program Manager`,
        assign: `Assign Leads`,
        assignRatio: `Assign Ratio`,
        save: `Save`,
        update: `Update`,
        appointment: "Appointment",
        pinRepeat: "Repeat Pin",
        pinNew: "New Pin",
        changePin: "Change Pin",
        leadsManagment: "Leads Management",
        reassignLeads: "Reassign Leads",
        forms: `Lead Forms`,
        form_id: `FORM ID`,
        logs: `Activity Logs`,
        domains: `Domains`,
        domain: `Domain`,
        day_limit: `Day Limit`,
        active: `Active`,
        warm: `Warm`,
        cname: `CNAME NAME`,
        cvalue: `CNAME VALUE`,
        bwemailSoftware: `Applications`,
        bwcampaigns: `Campaigns`,
        bwlists: `Lists`,
        bwtemplates: `Templates`,
        bwemails: `Emails`,
        bwsubscribers: `Subscribers`,
        bwleads: `Data`,
        bundesland: `State`,
        bundeslands: `States`,
        sector: `Sector`,
        sectors: `Sectors`,
        collectDate: `Collection Date`,
        german: `German`,
        from_name: `From Name`,
        from_email: `From Email`,
        whatsapp: `Whatsapp`,
        whatsappsettings: `Whatsapp Settings`,
        aramcco_code: `ARAMCCO Code`,
        registration_date: `Registration Date`,
        phone_alternative: `Phone #2`,
        birth_date: `Birth Date`,
        id_number: `ID Number`,
        last_pass_number: `Current Passport Number`,
        language_access: `Can Access Language Courses`,
        language_registered: `Registered in Lanugage Courses`,
        registration_contract_id: `Contract`,
        language_level_id: `Current Language Level`,
        last_language_certificate_id: `Last Language Certificate`,
        current_language_course_id: `Current Language Course`,
        notes: `Notes`,
        employee_id: `Employee`,
        candidates: `Candidates`,
        candidate: `Candidate`,
        courses: `Courses`,
        course: `Course`,
        teachers: `Teachers`,
        teacher: `Teacher`,
        start_date: `Start Date`,
        finish_date: `Finish Date`,
        course_level: `Course Level`,
        timezone: `Timezone`,
        /////////////
        captcha: `Please enter the code in the picture above`,
        wrong_captcha: `You have entered a wrong code`,
        only_numbers: `Only numbers allowed`,
        progressTitle: `Progress`,
        pdfReportsIconTooltip: `Generate Report`,
        generateReport: `Generate Report`,
        clearChart: `Clear Chart`,
        cant_be_imported: `User cant be imported`,
        domain_not_allowed: `Domain is not allowed`,
        allLegend: `Threshold Legend`,
        specialAccess: `Give user special access to ministry pages`,
        email: `Email`,
        password: `Password`,
        home: `Home`,
        login: `Login`,
        send: `send`,
        max_retries: `Max retries reached`,
        wrong_code: `Wrong code`,
        expired: `Expired`,
        user_already_exists: `User already exists`,
        success: `Success`,
        not_found: `Item Not found`,
        all_fields_required: `All fields required`,
        item_name_missing: `An item name is missing`,
        organisation: `Ministry Overview`,
        strategy: `Ministry Strategy`,
        orgProgress: `Ministry Progress`,
        orgStructure: `Ministry Org. Structure`,
        userSettings: `User Settings`,
        mySpace: `My Data`,
        notifications: `Notifications`,
        approvals: `Approval`,
        progress: `Progress`,
        reports: `Reports`,
        report: `Report`,
        managment: `Management`,
        employees: `Import Employees`,
        employeesSub: `Employee Management`,
        charts: `Performance Charts`,
        approvals: `Approvals`,
        orgStructureSetting: `Ministry Org. Structure Settings`,
        logout: `Log out`,
        pubReports: `Publish Reports`,
        bwsuppressions: `Suppressions`,

        ////// progress
        search: `Search`,
        totalProgress: `Total Progress`,
        goals: `Objectives`,
        goal: `Objective`,
        keyResult: `Key Result`,
        keyResults: `Key Results`,
        initiative: `Initiative`,
        initiatives: `Initiatives`,
        trend: `Variance`,
        progress: `OKRs`,
        mainResult: `KRs/Initiatives`,
        status: `Status`,
        change: `Edit`,
        detailsIconTooltip: "details",
        editIconTooltip: `Edit`,
        deleteIconTooltip: `Delete`,
        trending: {
          up: `Up`,
          down: `Down`,
          flat: `Stable`
        },
        addGoal: `Add Objective`,
        addGoalTitle: `Add Objective`,
        editGoalTitle: `Edit Objective`,
        parentGoal: `Parent Objective`,
        deleteGoalTitle: `Delete Objective`,
        addKeyResult: `Add Key Result`,
        addKeyResultTitle: `Add Key Result`,
        editKeyResultTitle: `Update Key Result`,
        deleteKeyResultTitle: `Delete Key Result`,
        addInit: `Add Initiative`,
        addInitTitle: `Add Initiative`,
        editInitTitle: `Edit Initiative`,
        deleteInitTitle: `Delete Initiative`,
        viewGoalTitle: `Objective Details`,
        viewKeyResultTitle: `Key Result Details`,
        viewInitTitle: `Initiative Details`,
        cancelBtn: `cancel`,
        addBtn: `add`,
        updateBtn: `Update`,
        add: `Add`,
        update: `Update`,
        delete: `Delete`,
        deleteMessage: `Are you sure you want to remove this item and all related items?`,
        startValue: `Start Value`,
        targetValue: `Target Value`,
        unite: `Unit`,
        currentValue: `Current Value`,
        weight: `Weight`,
        quarter: `Quarter`,
        meters: `Meter`,
        dollar: `US Dollar`,
        riyal: `Saudi Riyal`,
        rank: `Rank`,
        number: `Number`,
        mbps: `Mbps`,
        gbps: `Gbps`,
        percentage: `%`,
        quarter_one: `First Quarter`,
        quarter_two: `Second Quarter`,
        quarter_three: `Thrid Quarter`,
        quarter_four: `Fourth Quarter`,
        required: `Required`,
        upload: `Upload`,
        confidential: `Confidential`,
        normal: `Normal`,
        fileType: `File Type`,
        files: `Supporting Documents`,
        date: `Date`,
        new: `New`,
        theVision: `Vision`,
        theMission: `Mission`,
        theMessage: `Message`,
        usersSettings: `User Role Settings`,
        updateUser: `Update User`,
        platformSettings: `Platform Settings`,
        thresholdSettings: `Threshold Settings`,
        uniteSettings: `Unit Settings`,
        fileTypeSettings: `Supporting Documents’ Classification Settings`,
        allowedFilesSettings: `Allowed Files Settings`,
        AddThreshold: `Add a threshold`,
        name: `Name`,
        percentageWord: `Percentage`,
        saveSetting: `Save Settings`,
        slug: `Slug (no space)`,
        arabic: `Arabic`,
        english: `English`,
        AddUnite: `Add unit`,
        hundredError: `Must be less than 100`,
        AddFileType: `Add classification`,

        addMainLevel: `add main item`,
        addBelow: `add sub item`,
        phoneNumber: `Phone`,
        importUser: `Import User & Open an account`,
        employeeData: `Employee Data`,
        employee: `Employee`,
        accept: `Accept`,
        type: `Type`,
        reject: `Reject`,
        rejectMessage: `Rejection Note`,
        acceptedNotification: `Acceptance issued for`,
        rejectNotification: `Rejection issued for`,
        submissionNotification: `submitted for review`,
        deletionNotification: `Deleted`,
        pending: `Pending`,
        approved: `Approved`,
        there: `A`,
        createNewReport: `Create a new report`,
        dones: `Achievements`,
        todos: `Plans`,
        supports: `Problems`,
        comments: `Comments`,
        reportName: `Report Name`,
        fromDate: `From Date`,
        toDate: `To Date`,
        newReportNotification: `New Report`,
        by: `by`,
        submitReport: `Submit Report`,
        deleteReport: `Delete Report`,
        updateReport: `Update Report`,
        myReports: `My Reports`,
        employeesReports: `Employee Reports`,
        uniteThresholds: `Use single set of rules for all objects`,
        all: `All`,
        totals: `Totals`,
        stepName: `Threshold Name`,
        stepSettings: `Threshold Settings`,
        instituteSettings: `Edit Ministry Strategy`,
        lastSeen: `Last Update`,
        getEmailNotifications: `Get OKR notifications by email`,
        getReportsByEmail: `Get Reports notifications by email`,
        user_does_not_exist: `User does not exist`,
        viewIconTooltip: `View details`,
        reportsIconTooltip: `View Reports`,
        closeBtn: `Close`,
        SMSCode: `SMS Code`,
        transferLeads: `Transfer Leads`,
        roles: `Roles`,
        joblistings: `Job Listings`,
        vacancies: `Vacancies`,
        occupation: `Occupation`,
        city: `City`,
        states: `State`,
        contract_category_type: `Contract Type`,
        available_jobs_listings: `Available Job Listings`,
        contact_title: `Contact Title`,
        contact_name: `Contact Name`,
        contact_email: `Contact Email`,
        employer_name: `Employer Name`,
        employer_url: `Employer URL`,
        number_of_vacancies: `Number of Vacancies`,
        delete_job_listing: `Delete Job Listing`,
        bbcampaigns: `Campaigns`,
        filter: `Filter`,
        job_listing_category: `Job Listing Category`,
        delete_campaign: `Delete Campaign`,
        verified: `Verified`,
        delivered: `Delivered`,
        skip_campaign: `Skip Campaign`,
        cancel_schedule_send: `Cancel Schedule Sending`,
        stop_campaign: `Stop Campaign`,
        bbtemplates: `Templates`,
        title: `Title`,
        content: `Content`,
        opening_line: `Opening Line`,
        company_name: `Company name`,
        client_name: `Client name`,
        occupation: `Occupation`,
        variables: `Variables`,
        delete_template: `Delete Template`,
        ByteBricks: `ByteBricks`,
        candidate_name: `Candidate Name`,
        male: `Male`,
        female: `Female`,
        ready_to_use: `Ready to use`
      },
      ar: {
        domainsuppressions: "تعطيل الدومينات",
        last_login_at: "آخر تسجيل دخول",
        document_type: "نوع الوثيقة",
        print_candidate: "طباعة المرشح",
        print: "طبع",
        male: "ذكر",
        female: "أنثى",

        birth_place: "مكان الولادة",
        gender: "الجنس",

        //// nav
        whatsappofficialsettings: `Official WA Settings`,
        zoom: `Zoom`,
        limitRegister: `العدد المسموح`,
        candidates: `الملتحقين`,
        whatsapplog: `مراقبة`,
        advantages: `الميزات`,
        conditions_to_check: `الشروط`,
        emailSoftware: `الايميلات`,
        campaigns: `الحملات`,
        campaign: `حملة`,
        lists: `القوائم`,
        list: `قائمة`,
        templates: `القوالب`,
        template: `قالب`,
        accountCreated: `تم انشاء الحساب تواصل مع المدير للسماح لك بالدخول`,
        sent: `ارسال`,
        opened: `فتح`,
        clicked: `نقر`,
        lastChange: `اخر تحديث`,
        agent: `الموظف`,
        access: `الدخول`,
        userRole: `نوع المستخدم`,
        users: `مستخدمين`,
        user: `المستخدم العادي`,
        admin: `مدير`,
        superadmin: `مدير عام`,
        userEmail: `ايميل المستخدم`,
        userName: `اسم المستخدم`,
        close: `اغلاق`,
        position: `المسمى الوظيفي`,
        submitBtn: `تخزين`,
        reload: `اعادة تحميل`,
        subject: `العنوان`,
        fromName: `اسم المرسل`,
        fromEmail: `ايميل المرسل`,
        replyTo: `الردود الى`,
        lastUpdated: `اخر تحديث`,
        sendingActive: `جاري الارسال...`,
        inDraft: `مسودة`,
        alreadySent: `تم ارسال`,
        sendIconTooltip: `ارسال الان`,
        scheduleIconTooltip: `الارسال لاحقاً`,
        valid_email: `يرجى ادخال ايميل صحيح`,
        leads: `الطلبات`,
        subscribers: `ايميلات الملتحقين`,
        suppressions: `منع الارسال`,
        offices: `المكاتب`,
        create: `انشاء جديد`,
        areYouSureOfDelete: `هل انت متأكد بانك تريد حذف |item| بشكل نهائي؟`,
        deleteBtn: `مسح`,
        interviews: `المقابلات`,
        automation: `اتمتة`,
        delay: `كمية التأجيل`,
        delay_unit: `الوحدة`,
        programs: `البرامج`,
        phones: `ارقام هواتف`,
        subject: `العنوان`,
        limit: `العدد`,
        program: `البرنامج`,
        emails: `الايميلات`,
        delivered: `وصل`,
        opened: `فتح`,
        clicked: `نقر`,
        bounced: `باونس`,
        pleaseEnterPin: `الرجاء ادخال الرقم السري`,
        pin: `الرقم السري`,
        continue: `اكمال الجلسة`,
        edit: `تعديل`,
        country: `الدولة`,
        phone: `رقم الهاتف`,
        status: `الحالة`,
        note: `ملاحظة`,
        user: `موظف`,
        program_name: `البرنامج`,
        country_name: `الدولة`,
        user_name: `الموظف`,
        status_name: `الحالة`,
        source: `المصدر`,
        countries: `الدول`,
        statuses: `الحالات`,
        AddItem: `اضافة`,
        french: `فرنسي`,
        duplicate: `مكرر`,
        userCountries: `دول الموظف`,
        userPrograms: `برامج الموظف`,
        userRoles: `انواع المستخدم`,
        hq: `الفرع الرئيسي`,
        branchManager: `مدير فرع`,
        programManager: `مدير برنامج`,
        assign: `توزيع الطلبات`,
        assignRatio: `نسبة التوزيع`,
        save: `تخزين`,
        update: `تحديث`,
        appointment: "الموعد",
        pinRepeat: "الرقم السري مجددا",
        pinNew: "الرقم السري الجديد",
        changePin: "تبديل الرقم السري",
        leadsManagment: "ادارة الطلبات",
        reassignLeads: "اعادة توزيع الطلبات",
        logs: `سجل التغيرات`,
        roles: `الوظائف`,
        domains: `Domains`,
        bwsuppressions: `Suppressions`,
        whatsapp: `واتساب`,
        whatsappsettings: `اعدادات واتساب`,
        /////////////
        captcha: `الرجاء ادخال الرمز الموجود في الصورة`,
        wrong_captcha: `لقد قمت بادخال رمز خطا`,
        only_numbers: `يسمح بأدخال الارقام فقط`,
        progressTitle: `التقدم`,
        pdfReportsIconTooltip: `انشاء تقرير`,
        generateReport: `انشاء تقرير`,
        clearChart: `اعادة تعيين`,
        cant_be_imported: `لا يمكن استيراد هذا الموظف`,
        domain_not_allowed: `هذا النطاق غير مسموح به`,
        allLegend: `مفتاح العتبات`,
        specialAccess: `اعطاء المستخدم صلاحيات لعرض صفحات الوزارة`,
        email: `الايميل`,
        password: `كلمة السر`,
        login: `تسجيل الدخول`,
        send: `ارسال`,
        home: `الرئيسية`,
        max_retries: `تخطيت عدد المحاولات المسموحة`,
        wrong_code: `خطأ في كتابة الرمز، يرجى المحاولة مرة اخرى`,
        expired: `انهت صلاحية الجلسة`,
        user_already_exists: `تم استيراد هذا المستخدم سابقاً`,
        success: `تمت العملية بنجاح`,
        not_found: `العنصر غير موجود`,
        all_fields_required: `جميع الحقول مطلوبة`,
        item_name_missing: `احد العناصر ينقصه اسم`,
        organisation: `نظرة عامة على الوزارة`,
        strategy: `استراتيجية الوزارة`,
        orgProgress: `مقياس انجاز الوزارة`,
        orgStructure: `الهيكل التنظيمي للوزارة`,
        userSettings: `اعدادات المستخدم`,
        mySpace: `المساحة الشخصية`,
        notifications: `التنبيهات`,
        progress: `الاهداف والمنجزات`,
        reports: `التقارير`,
        report: `تقرير`,
        managment: `لوحة التحكم`,
        employees: `استيراد الموظفين`,
        employeesSub: `ادارة الموظفين`,
        charts: `الرسم البياني للأداء`,
        approvals: `موافقاتي`,
        user: `حسابي`,
        orgStructureSetting: `تعديل الهيكل التنظيمي`,
        settings: `اعدادات`,
        pubReports: `اصدار تقرير`,
        logout: `الخروج`,
        time: `الوقت`,
        forms: `الطلبات`,
        form_id: `FORM ID`,
        ////// progress
        search: `ابحث`,
        totalProgress: `اجمالي الانجازات`,
        goals: `الاهداف`,
        goal: `هدف`,
        keyResult: `نتيجة رئيسية`,
        keyResults: `نتائج رئيسية`,
        initiative: `مبادرة`,
        initiatives: `مبادرات`,
        trend: `التباين`,
        progress: `الاهداف والمنجزات الرئيسة`,
        mainResult: `النتائج/المبادرات`,
        status: `الحالة`,
        change: `تعديل`,
        detailsIconTooltip: "تفاصيل",
        editIconTooltip: `تعديل`,
        deleteIconTooltip: `مسح`,
        trending: {
          up: `تقدم`,
          down: `تراجع`,
          flat: `ثبات`
        },
        addGoal: `اضافة هدف`,
        addGoalTitle: `اضافة هدف`,
        editGoalTitle: `تعديل هدف`,
        parentGoal: `هدف علوي يرتبط به`,
        deleteGoalTitle: `مسح هدف`,
        addKeyResult: `اضافة نتيجة`,
        addKeyResultTitle: `اضافة نتيجة`,
        editKeyResultTitle: `تعديل نتيجة`,
        deleteKeyResultTitle: `مسح نتيجة`,
        addInit: `اضافة مبادرة`,
        addInitTitle: `اضافة مبادرة`,
        editInitTitle: `تعديل مبادرة`,
        deleteInitTitle: `مسح مبادرة`,
        viewGoalTitle: `تفاصيل الهدف`,
        viewKeyResultTitle: `تفاصيل النتيجة الرئيسية`,
        viewInitTitle: `تفاصيل المبادرة`,
        cancelBtn: `الغاء`,
        addBtn: `اضافة`,
        updateBtn: `تحديث`,
        add: `اضافة`,
        update: `تعديل`,
        delete: `مسح`,
        deleteMessage: `هل انت متأكد من ازالة هذا العنصر وكل ما يتعلق به بشكل نهائي؟`,
        startValue: `قيمة البداية`,
        targetValue: `قيمة الهدف`,
        unite: `وحدة القياس`,
        currentValue: `القيمة الحالية`,
        weight: `قيمة المساهمة`,
        quarter: `الربع`,
        meters: `متر`,
        dollar: `دولار امريكي`,
        riyal: `ريال سعودي`,
        rank: `ترتيب`,
        number: `عدد`,
        mbps: `Mbps`,
        gbps: `Gbps`,
        percentage: `%`,
        quarter_one: `الربع الاول`,
        quarter_two: `الربع الثاني`,
        quarter_three: `الربع الثالث`,
        quarter_four: `الربع الرابع`,
        required: `مطلوب`,
        upload: `تحميل ملف`,
        confidential: `سري`,
        normal: `عادي`,
        fileType: `نوع الملف`,
        files: `ملفات`,
        date: `التاريخ`,
        new: `جديد`,
        theVision: `الرؤية`,
        theMission: `المهمة`,
        theMessage: `الرسالة`,
        usersSettings: `اعدادات انواع المستخدمين`,
        updateUser: `تحديث المستخدم`,
        platformSettings: `اعدادات النظام`,
        thresholdSettings: `اعدادات العتبات`,
        uniteSettings: `اعدادات وحدات القياس`,
        fileTypeSettings: `اعدادات تصنيف سرية المستندات الداعمة`,
        allowedFilesSettings: `اعدادات انواع الملفات المسموحة`,
        AddThreshold: `اضافة عتبة`,
        name: `الاسم`,
        percentageWord: `النسبة`,
        saveSetting: `تخزين الاعدادات`,
        slug: `اسم التخزين (دون فراغ)`,
        arabic: `العربية`,
        english: `الانجليزية`,
        AddUnite: `اضافة وحدة`,
        hundredError: `يجب ان يكون اقل من 100`,
        AddFileType: `اضافة تصنيف`,

        addMainLevel: `اضافة منصب اساسي`,
        addBelow: `اضافة منصب فرعي`,
        phoneNumber: `رقم الهاتف`,
        importUser: `استيراد المستخدم وانشاء حساب`,
        employeeData: `معلومات الموظف`,
        employee: `الموظف`,
        accept: `موافقة`,
        type: `النوع`,
        reject: `رفض`,
        rejectMessage: `ملاحظة الرفض`,
        acceptedNotification: `تم الموافقة على`,
        rejectNotification: `تم رفض`,
        submissionNotification: `بحاجة للمراجعة`,
        deletionNotification: `تم مسح`,
        pending: `بانتظار المراجعة`,
        approved: `حصل على الموافقة`,
        there: `هناك`,
        createNewReport: `انشاء تقرير جديد`,
        dones: `انجازات`,
        todos: `خطط`,
        supports: `بحاجة دعم`,
        comments: `تعليقات`,
        reportName: `اسم التقرير`,
        fromDate: `من تاريخ`,
        domainSetup: `اعدادات النظام`,
        "domain-setup": `اعدادات النظام`,
        domain: `النظام`,
        toDate: `الى تاريخ`,
        newReportNotification: `تقرير جديد بعنوان`,
        by: `بواسطة`,
        submitReport: `تقديم التقرير`,
        deleteReport: `مسح التقرير`,
        updateReport: `تحديث التقرير`,
        uniteThresholds: `توحيد الاعدادات لجميع الفئات من المنجزات`,
        myReports: `تقاريري`,
        employeesReports: `تقارير الموظفين`,
        all: `الكل`,
        totals: `اجمالي الانجازات`,
        stepName: `اسم العتبة`,
        stepSettings: `اعدادات العتبة`,
        instituteSettings: `تعديل استراتيجية الوزارة`,
        lastSeen: `اخر تحديث`,
        getEmailNotifications: `الحصول على تنبيهات الأهداف و المنجزات و المبادرات عبر الايميل`,
        getReportsByEmail: `الحصول على تنبيهات التقارير عبر الايميل`,
        user_does_not_exist: `هذا المستخدم غير موجود`,
        viewIconTooltip: `الاطلاع على التفاصيل`,
        reportsIconTooltip: `الاطلاع على التقارير`,
        closeBtn: `اغلاق`,
        SMSCode: `الرمز المرسل في الرسالة النصية`,
        transferLeads: `تحويل الطلبات`,
        joblistings: `قوائم الوظائف`,
        vacancies: `الوظائف الشاغرة`,
        occupation: `المهنة`,
        city: `المدينة`,
        states: `الولاية`,
        contract_category_type: `نوع العقد`,
        available_jobs_listings: `قوائم الوظائف المتاحة`,
        contact_title: `عنوان الاتصال`,
        contact_name: `اسم جهة الاتصال`,
        contact_email: `البريد الإلكتروني لجهة الاتصال`,
        employer_name: `اسم صاحب العمل`,
        employer_url: `رابط صاحب العمل`,
        number_of_vacancies: `عدد الوظائف الشاغرة`,
        delete_job_listing: `حذف قائمة الوظائف`,
        bbcampaigns: `الحملات`,
        filter: `تصفية`,
        job_listing_category: `فئة قائمة الوظائف`,
        delete_campaign: `حذف الحملة`,
        stop_campaign: `ايقاف الحملة`,
        cancel_schedule_send: `الغاء الحجز للارسال`,
        skip_campaign: `تخطي الحملة`,
        delivered: `تم الارسال`,
        bbtemplates: "القوالب",
        title: "العنوان",
        content: "المحتوى",
        opening_line: "الجملة الافتتاحية",
        company_name: "اسم الشركة",
        client_name: "اسم العميل",
        occupation: "المهنة",
        variables: "المتغيرات",
        delete_template: "حذف القوالب",
        candidate_name: "اسم الطالب",
        domain_suppressions: "تعطيل الدومينات",
        cloudflare_status: "حالة كلاود فلير",
        aws_status: "حالة امازون",
        not_ready: "غير جاهز"
      },
      fr: {}
    },
    modelMenu: [
      {
        icon: "email",
        text: "emailSoftware",
        roles: ["master", "superadmin"],
        path: "/mailer",
        subs: [
          {
            icon: "insights",
            text: "campaigns",
            path: "/campaigns",
            roles: ["master", "superadmin"]
          },
          {
            icon: "list",
            text: "lists",
            path: "/lists",
            roles: ["master", "superadmin"]
          },
          {
            icon: "table_chart",
            text: "templates",
            path: "/templates",
            roles: ["master", "superadmin"]
          },
          {
            icon: "send",
            text: "emails",
            path: "/emails",
            roles: ["master", "superadmin"]
          },
          {
            icon: "task_alt",
            text: "subscribers",
            path: "/subscribers",
            roles: ["master", "superadmin"]
          },
          {
            icon: "cancel_schedule_send",
            text: "suppressions",
            path: "/suppressions",
            roles: ["master", "superadmin"]
          },
          {
            icon: "cancel_schedule_send",
            text: "domain_suppressions",
            path: "/domain-suppressions",
            roles: ["master", "superadmin"]
          }
        ]
      },
      {
        icon: "work",
        text: "bwemailSoftware",
        roles: ["master", "de_superadmin", "de_admin", "de_user"],
        path: "/bwmailer",
        subs: [
          {
            icon: "contact_page",
            text: "bwleads",
            path: "/bw-leads",
            roles: ["master", "de_superadmin", "de_admin", "de_user"]
          },
          {
            icon: "insights",
            text: "bwcampaigns",
            path: "/bw-campaigns",
            roles: ["master", "de_superadmin", "de_admin", "de_user"]
          },
          { icon: "list", text: "bwlists", path: "/bw-lists", roles: ["master", "de_superadmin"] },
          {
            icon: "table_chart",
            text: "bwtemplates",
            path: "/bw-templates",
            roles: ["master", "de_superadmin", "de_admin", "de_user"]
          },
          {
            icon: "send",
            text: "bwemails",
            path: "/bw-emails",
            roles: ["master", "de_superadmin"]
          },
          {
            icon: "task_alt",
            text: "bwsubscribers",
            path: "/bw-subscribers",
            roles: ["master", "de_superadmin"]
          },
          {
            icon: "cancel_schedule_send",
            text: "bwsuppressions",
            path: "/bw-suppressions",
            roles: ["master", "de_superadmin", "de_user"]
          },
          {
            icon: "cancel_schedule_send",
            text: "domain_suppressions",
            path: "/domain-suppressions",
            roles: ["master", "de_superadmin", "de_user"]
          }
        ]
      },
      {
        icon: "bolt",
        text: "ByteBricks",
        path: "/ByteBricks",
        roles: ["master", "de_superadmin", "de_admin", "de_user"],
        subs: [
          {
            icon: "engineering",
            text: "joblistings",
            path: "/job-listings",
            roles: ["master", "superadmin", "admin", "user", "de_superadmin", "de_admin", "de_user"]
          },
          {
            icon: "insights",
            text: "bbcampaigns",
            path: "/bb-campaigns",
            roles: ["master", "superadmin", "admin", "user", "de_superadmin", "de_admin", "de_user"]
          },
          {
            icon: "table_chart",
            text: "bbtemplates",
            path: "/bb-templates",
            roles: ["master", "superadmin", "admin", "user", "de_superadmin", "de_admin", "de_user"]
          }
        ]
      },
      {
        icon: "groups",
        text: "leads",
        path: "/my-leads",
        roles: ["master", "superadmin", "admin", "user", "de_superadmin"],
        subs: [
          {
            icon: "contact_page",
            text: "leads",
            path: "/leads",
            roles: ["master", "superadmin", "admin", "user", "de_superadmin"]
          },
          {
            icon: "speed",
            text: "leadsManagment",
            path: "/leads-management",
            roles: ["master", "superadmin", "admin"]
          },
          {
            icon: "speed",
            text: "leadCounters",
            path: "/lead-counters",
            roles: ["master", "superadmin", "admin"]
          }
        ]
      },
      {
        icon: "summarize",
        text: "reports",
        path: "/my-leads",
        roles: ["master", "superadmin"],
        subs: [
          {
            icon: "health_and_safety",
            text: "health",
            path: "/health",
            roles: ["master", "superadmin"]
          },
          { icon: "local_atm", text: "ads", path: "/ads", roles: ["master", "superadmin"] },
          {
            icon: "folder_shared",
            text: "leadsReport",
            path: "/leads-report",
            roles: ["master", "superadmin"]
          }
        ]
      },
      {
        icon: "verified_user",
        text: "candidates",
        path: "/candidates",
        roles: ["master", "superadmin", "admin", "user", "de_superadmin"],
        subs: [
          {
            icon: "face",
            text: "candidates",
            path: "/candidates",
            roles: ["master", "superadmin", "admin", "user", "de_superadmin"]
          },
          {
            icon: "database",
            text: "readyCandidates",
            path: "/ready-candidates",
            roles: ["master", "superadmin", "admin", "user", "de_superadmin", "de_admin", "de_user"]
          },
          {
            icon: "local_library",
            text: "courses",
            path: "/courses",
            roles: ["master", "superadmin", "admin"]
          },
          {
            icon: "timeline",
            text: "candidateUpdates",
            path: "/candidateUpdates",
            roles: ["master", "superadmin", "admin", "user", "de_superadmin", "de_admin", "de_user"]
          },
          {
            icon: "leaderboard",
            text: "candidateEvaluations",
            path: "/candidateEvaluations",
            roles: ["master", "superadmin", "admin", "user", "de_superadmin", "de_admin", "de_user"]
          },
          {
            icon: "slideshow",
            text: "candidateInterviews",
            path: "/candidateInterviews",
            roles: ["master", "superadmin", "admin", "user", "de_superadmin", "de_admin", "de_user"]
          },
          {
            icon: "feed",
            text: "candidateSubmissionRequest",
            path: "/candidateSubmissionRequest",
            roles: ["master", "superadmin", "admin", "user", "de_superadmin", "de_admin", "de_user"]
          }
        ]
      },
      {
        icon: "tv",
        text: "online",
        path: "/online",
        roles: ["master", "superadmin"],
        subs: [
          {
            icon: "recent_actors",
            text: "onlineCandidates",
            path: "/online-candidates",
            roles: ["master", "superadmin"]
          },
          {
            icon: "video_camera_front",
            text: "onlineAppointments",
            path: "/online-appointments",
            roles: ["master", "superadmin"]
          },
          {
            icon: "subscriptions",
            text: "onlineSeminars",
            path: "/online-seminars",
            roles: ["master", "superadmin"]
          },
          {
            icon: "edit_calendar",
            text: "onlineAppointmentsSettings",
            path: "/online-appointments-settings",
            roles: ["master", "superadmin"]
          },
          {
            icon: "video_settings",
            text: "onlineSeminarsSettings",
            path: "/online-seminars-settings",
            roles: ["master", "superadmin"]
          }
        ]
      },
      {
        icon: "whatsapp",
        text: "whatsapp",
        path: "/whatsapp",
        roles: ["master", "superadmin"],
        subs: [
          {
            icon: "tune",
            text: "whatsappsettings",
            path: "/whatsapp-settings",
            roles: ["master", "superadmin"]
          },
          {
            icon: "tune",
            text: "whatsappofficialsettings",
            path: "/whatsapp-official-settings",
            roles: ["master", "superadmin"]
          },
          { icon: "whatsapp", text: "whatsapplog", path: "/whatsapp-log", roles: ["master"] }
        ]
      },
      {
        icon: "check_circle",
        text: "notifications",
        path: "/notifications",
        roles: ["master", "superadmin", "admin", "user", "de_superadmin", "de_admin", "de_user"]
      },
      {
        icon: "tune",
        text: "managment",
        path: "/managment",
        roles: ["master", "superadmin", "admin", "user", "de_superadmin", "de_admin", "de_user"],
        subs: [
          {
            icon: "health_and_safety",
            text: "health",
            path: "/health",
            roles: ["master", "superadmin"]
          },
          {
            icon: "clear_all",
            text: "logs",
            path: "/logs",
            roles: ["master", "superadmin", "admin"]
          },
          {
            icon: "supervised_user_circle",
            text: "employeesSub",
            path: "/users",
            roles: ["master", "superadmin"]
          },
          {
            icon: "school",
            text: "teachers",
            path: "/teachers",
            roles: ["master", "superadmin", "admin"]
          },
          {
            icon: "call_to_action",
            text: "forms",
            path: "/forms",
            roles: ["master", "superadmin"]
          },
          { icon: "duo", text: "zoom", path: "/zoom", roles: ["master", "superadmin"] },
          {
            icon: "corporate_fare",
            text: "offices",
            path: "/offices",
            roles: ["master", "superadmin"]
          },
          {
            icon: "videocam",
            text: "interviews",
            path: "/interviews",
            roles: ["master", "superadmin"]
          },
          {
            icon: "schema",
            text: "automation",
            path: "/automation",
            roles: ["master", "superadmin"]
          },
          { icon: "http", text: "domains", path: "/domains", roles: ["master", "superadmin"] },
          {
            icon: "settings",
            text: "settings",
            path: "/settings",
            roles: ["master", "superadmin", "de_superadmin"]
          },
          {
            icon: "password",
            text: "pin",
            path: "/pin",
            roles: ["master", "superadmin", "admin", "user", "de_superadmin", "de_admin", "de_user"]
          },
          {
            icon: "feed",
            text: "contracts",
            path: "/contracts",
            roles: ["master", "de_superadmin"]
          },
          {
            icon: "web",
            text: "domainSetup",
            path: "/domainSetup",
            roles: ["master", "superadmin", "admin", "user", "de_superadmin", "de_admin", "de_user"]
          },
          {
            icon: "feed",
            text: "evaluationAppointmentSettings",
            path: "/evaluationAppointmentSettings",
            roles: ["master", "superadmin", "admin", "user", "de_superadmin", "de_admin", "de_user"]
          }
        ]
      },
      {
        icon: "person",
        text: "profile",
        path: "/profile",
        roles: ["master", "superadmin", "admin", "user", "de_superadmin", "de_admin", "de_user"]
      }
    ],
    cities: [
      "Berlin",
      "Hamburg",
      "München",
      "Köln",
      "Frankfurt am Main",
      "Stuttgart",
      "Düsseldorf",
      "Dortmund",
      "Essen",
      "Leipzig",
      "Bremen",
      "Dresden",
      "Hannover",
      "Nürnberg",
      "Duisburg",
      "Bochum",
      "Wuppertal",
      "Bielefeld",
      "Bonn",
      "Münster",
      "Karlsruhe",
      "Mannheim",
      "Augsburg",
      "Wiesbaden",
      "Gelsenkirchen",
      "Mönchengladbach",
      "Braunschweig",
      "Chemnitz",
      "Kiel",
      "Aachen",
      "Saale",
      "Magdeburg",
      "Freiburg im Breisgau",
      "Krefeld",
      "Lübeck",
      "Oberhausen",
      "Erfurt",
      "Mainz",
      "Rostock",
      "Kassel",
      "Hagen",
      "Hamm",
      "Saarbrücken",
      "Mülheim an der Ruhr",
      "Potsdam",
      "Ludwigshafen am Rhein",
      "Oldenburg",
      "Leverkusen",
      "Osnabrück",
      "Solingen",
      "Heidelberg",
      "Herne",
      "Neuss",
      "Darmstadt",
      "Paderborn",
      "Regensburg",
      "Ingolstadt",
      "Würzburg",
      "Fürth",
      "Wolfsburg",
      "Offenbach am Main",
      "Ulm",
      "Heilbronn",
      "Pforzheim",
      "Göttingen",
      "Bottrop",
      "Trier",
      "Recklinghausen",
      "Reutlingen",
      "Bremerhaven",
      "Koblenz",
      "Bergisch Gladbach",
      "Jena",
      "Remscheid",
      "Erlangen",
      "Moers",
      "Siegen",
      "Hildesheim",
      "Salzgitter",
      "Kaiserslautern"
    ],
    menu: [],
    online: false,
    centralLogin: false,
    loginDialog: null,
    globalLoading: null,
    user: null,
    users: [],
    uid: null,
    language: "en",
    notifications: [],
    approvals: [],
    settings: {
      baseUrl: ``,
      apiBase: ``,
      public: ``
    },
    settingsSecond: {
      baseUrl: ``,
      apiBase: ``,
      public: ``
    },
    userRoles: ["user", "admin", "superadmin", "master", "de_user", "de_admin", "de_superadmin"],
    usersLevels: [],
    reports: [],

    products: [],
    raw_products: [],
    sort_products: [],
    meta_products: [],
    cart: [],
    customer: {},
    show_cart: false,
    cart_total: 0,
    delivery_fees: 0,
    cart_delivery_fees: 0,
    free_delivery_limit: 0,
    tax: 0,
    cart_tax: 0
  },
  modules: {},
  getters: {
    getProducts(state) {
      return state.products;
    },
    cart(state) {
      return state.cart;
    }
  },
  mutations: {
    unAuthLogout(state) {
      state.access_token = null;
      state.user = null;
      state.uid = null;
      state.centralLogin = false;
      state.menu = [];
      state.globalLoading = [];
      state.users = [];
      state.notifications = [];
      router.push("/login").catch(x => {});
    },
    setOnline(state, payload) {
      state.online = payload == 1 ? true : false;
    },
    setBaseUrl(state, payload) {
      state.settings.baseUrl = `${payload.base}`;
      state.settings.apiBase = `${payload.base}/api/v1`;
      state.settings.public = `${payload.base}/storage/app/`;

      state.settingsSecond.baseUrl = `${payload.baseSecond}`;
      state.settingsSecond.apiBase = `${payload.baseSecond}/api/v1`;
      state.settingsSecond.public = `${payload.baseSecond}/storage/app/`;
    },
    updateNotifications(state, payload) {
      state.notifications = [...payload];
    },
    updateApprovals(state, payload) {
      state.approvals = [...payload];
    },
    updateSettings(state, payload) {
      state.settings = { ...state.settings, ...payload };
    },
    loadProducts(state, products) {
      return new Promise(async (res, rej) => {
        console.log("state.country", state.country);
        console.log("state.sort_products", state.sort_products);
        console.log("state.meta_products", state.meta_products);
        console.log(
          "state.sort_products.countries",
          state.sort_products.map(x => x.country_id)
        );
        console.log("products", products);
        console.log(
          "products IMGS",
          products.filter(x => x.images.length > 1)
        );
        let filtered_products = state.sort_products.filter(x =>
          x.countries.includes(state.country.id)
        );
        console.log("filtered_products", filtered_products);
        let final_products = filtered_products.length
          ? products.filter(x => filtered_products.map(y => y.product_id).includes(x.id))
          : products;
        state.raw_products = final_products;
        console.log("final_products", final_products);
        for (let i = 0; i < final_products.length; i++) {
          let f = final_products[i].prices.filter(
            x => x.web && x.country && (x.country.name == "ALL" || x.country.id == state.country.id)
          );
          if (f.length) {
            console.log("final_products[i]", final_products[i].sku);
            console.log("final_products[i]", final_products[i].id);
            console.log("final_products[i]", final_products[i].name_ar);
            final_products[i].price_name = f[0].name;
            final_products[i].base_price = parseFloat(parseFloat(f[0].value).toFixed(1));
            final_products[i].price = parseFloat(
              (parseFloat(f[0].value) * state.currency_factor).toFixed(1)
            );
            if (state.tax) {
              final_products[i].price = parseFloat(
                (parseFloat(final_products[i].price) + final_products[i].price * state.tax).toFixed(
                  1
                )
              );
            }
          } else {
            final_products[i].price = 0;
            if (!state.is_landing_page) {
              let f = final_products[i].prices.filter(x => x.web && x.default);
              if (f.length) {
                final_products[i].price_name = f[0].name;
                final_products[i].base_price = parseFloat(parseFloat(f[0].value).toFixed(1));
                final_products[i].price = parseFloat(
                  (parseFloat(f[0].value) * state.currency_factor).toFixed(1)
                );
                if (state.tax) {
                  final_products[i].price = parseFloat(
                    (
                      parseFloat(final_products[i].price) +
                      final_products[i].price * state.tax
                    ).toFixed(1)
                  );
                }
              } else {
                final_products[i].price = 0;
              }
            }
          }
          if (
            final_products[i].web &&
            !state.products.map(x => x.id).includes(final_products[i].id)
          ) {
            state.products.push(final_products[i]);
          }
        }
        console.log("state.products-", state.products);
        res(true);
      });
    },
    addProductToCart(state, product) {
      product.order_quantity = 1;
      product.total = product.order_quantity * product.price;
      state.cart.push(product);
    },
    removeProductFromCart(state, product) {
      state.cart.splice(
        state.cart.findIndex(x => x.sku == product.sku),
        1
      );
    },
    increaseQuantity(state, product) {
      let current_product = state.cart.filter(x => x.sku == product.sku)[0];
      if (current_product.order_quantity < 3) {
        current_product.order_quantity += 1;
        current_product.total = parseFloat(
          (parseFloat(current_product.order_quantity) * current_product.price).toFixed(1)
        );
        state.cart.splice(
          state.cart.findIndex(x => x.sku == product.sku),
          1,
          current_product
        );
      }
    },
    decreaseQuantity(state, product) {
      let current_product = state.cart.filter(x => x.sku == product.sku)[0];
      if (current_product.order_quantity > 1) {
        current_product.order_quantity -= 1;
        current_product.total = parseFloat(
          (parseFloat(current_product.order_quantity) * current_product.price).toFixed(1)
        );
        state.cart.splice(
          state.cart.findIndex(x => x.sku == product.sku),
          1,
          current_product
        );
      }
    },
    showCart(state, status) {
      state.show_cart = status;
    },
    setCartTotal(state, payload) {
      return new Promise(async (res, rej) => {
        let total = 0;
        for (let i = 0; i < state.cart.length; i++) {
          const p = state.cart[i];
          total += p.total;
        }
        if (total < state.free_delivery_limit && !state.free_delivery) {
          state.cart_delivery_fees = state.delivery_fees;
          total += state.delivery_fees;
        } else {
          state.cart_delivery_fees = 0;
        }
        state.cart_total = parseFloat(total.toFixed(1));
        localStorage.cart = JSON.stringify(state.cart);
        localStorage.cart_timestamp = new Date().getTime();
        res(true);
      });
    },
    loadCart(state) {
      return new Promise(async (res, rej) => {
        if (localStorage.cart) {
          let now = new Date().getTime();
          if (now - localStorage.cart_timestamp < 24 * 60 * 60 * 1000) {
            state.cart = JSON.parse(localStorage.cart);
          }
        }
        res(true);
      });
    }
  },
  actions: {
    setSettingsBase({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        commit("setBaseUrl", payload);
        resolve(true);
      });
    },
    updateUser({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        let n = payload;
        //// AUTH SET CHECK ///
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          function(config) {
            let token = state.access_token;
            if (token) {
              config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
          },
          function(error) {
            return Promise.reject(error);
          }
        );
        axios.interceptors.response.use(
          async response => {
            return response;
          },
          async error => {
            if (error.response.status === 401) {
              // await dispatch('goOffline')
              commit("unAuthLogout");
            }
            return error;
          }
        );
        //// AUTH SET CHECK ///
        let a = await axios
          .put(`${state.settings.apiBase}/users/${n.id}`, n, headers)
          .then(x => x.data);
        if (state.user.id == n.id) {
          await dispatch("getUser");
        }
        resolve(a);
      });
    },
    getUser({ commit, dispatch, state }) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          function(config) {
            let token = state.access_token;
            if (token) {
              config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
          },
          function(error) {
            return Promise.reject(error);
          }
        );
        axios.interceptors.response.use(
          async response => {
            return response;
          },
          async error => {
            if (error.response.status === 401) {
              // await dispatch('goOffline')
              commit("unAuthLogout");
            }
            return error;
          }
        );
        let a = await axios
          .get(`${state.settings.apiBase}/user/me`)
          .then(x => x.data)
          .catch(error => {});
        console.log(a);
        resolve(a);
      });
    },
    onlineCheck({ commit, dispatch, state }) {
      return new Promise(async (resolve, reject) => {
        // headers.Authorization = `Bearer ${state.access_token}`
        // axios.interceptors.request.use(function (config) {
        //   let token = state.access_token
        //   if (token) {
        //     config.headers['Authorization'] = `Bearer ${token}`
        //   }
        //   return config;
        // }, function (error) {
        //   return Promise.reject(error);
        // })
        // axios.interceptors.response.use(async response => {
        //   return response;
        // }, async error => {
        //   if (error.response.status === 401) {
        //     // await dispatch('goOffline')
        //     commit('unAuthLogout')
        //   }
        //   return error;
        // });
        // let a = await axios.get(`${state.settings.apiBase}/user/online`)
        //   .then(x => x.data).catch(error=>{})
        //   commit('setOnline', a)
        resolve({});
      });
    },
    goOffline({ commit, dispatch, state }) {
      return new Promise(async (resolve, reject) => {
        if (state.user && state.user.id) {
          let a = await axios
            .get(`${state.settings.apiBase}/user/gooffline/${state.user.id}`)
            .then(x => x.data)
            .catch(error => {});
          commit("setOnline", 0);
          resolve(a);
        } else {
          resolve(false);
        }
      });
    },
    logout({ commit, dispatch, state }) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          function(config) {
            // assume your access token is stored in local storage
            // (it should really be somewhere more secure but I digress for simplicity)
            let token = state.access_token;
            if (token) {
              config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
          },
          function(error) {
            // Do something with request error
            return Promise.reject(error);
          }
        );
        try {
          let a = await axios.get(`${state.settings.apiBase}/user/logout`).then(x => x.data);
          resolve(a);
        } catch (error) {
          resolve(false);
        }
      });
    },
    newCampaign({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          function(config) {
            let token = state.access_token;
            if (token) {
              config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
          },
          function(error) {
            return Promise.reject(error);
          }
        );
        axios.interceptors.response.use(
          async response => {
            return response;
          },
          async error => {
            if (error.response.status === 401) {
              // await dispatch('goOffline')
              commit("unAuthLogout");
            }
            return error;
          }
        );
        let a = await axios
          .post(`${state.settings.apiBase}/lists-un`, payload)
          .then(x => x.data)
          .catch(error => {});
        console.log(a);
        resolve(a);
      });
    },
    loadAllResource({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          function(config) {
            let token = state.access_token;
            if (token) {
              config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
          },
          function(error) {
            return Promise.reject(error);
          }
        );
        axios.interceptors.response.use(
          async response => {
            return response;
          },
          async error => {
            if (error.response.status === 401) {
              // await dispatch('goOffline')
              commit("unAuthLogout");
            }
            return error;
          }
        );
        console.log(`${state.settings.apiBase}${payload.resource}-all`);
        let a = await axios
          .get(`${state.settings.apiBase}${payload.resource}-all`)
          .then(x => x.data)
          .catch(error => {});
        console.log(a);
        resolve(a);
      });
    },
    postResource({ commit, dispatch, state }, payload) {
      return new Promise((resolve, reject) => {
        customAxios
          .post(payload.resource, { ...payload.value })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getResource({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          function(config) {
            let token = state.access_token;
            if (token) {
              config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
          },
          function(error) {
            return Promise.reject(error);
          }
        );
        axios.interceptors.response.use(
          async response => {
            return response;
          },
          async error => {
            if (error.response.status === 401) {
              // await dispatch('goOffline')
              commit("unAuthLogout");
            }
            return error;
          }
        );
        console.log(
          `${state.settings.apiBase}${payload.resource}${payload.page ? payload.page : ""}`
        );

        let a = await axios
          .get(`${state.settings.apiBase}${payload.resource}${payload.page ? payload.page : ""}`)
          .then(x => x.data)
          .catch(error => {});
        console.log(a);
        resolve(a);
      });
    },
    getSecondResource({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          function(config) {
            let token = state.access_token;
            if (token) {
              config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
          },
          function(error) {
            return Promise.reject(error);
          }
        );
        axios.interceptors.response.use(
          async response => {
            return response;
          },
          async error => {
            if (error.response.status === 401) {
              // await dispatch('goOffline')
              commit("unAuthLogout");
            }
            return error;
          }
        );
        console.log(
          `${state.settingsSecond.apiBase}${payload.resource}${payload.page ? payload.page : ""}`
        );

        let a = await axios
          .get(
            `${state.settingsSecond.apiBase}${payload.resource}${payload.page ? payload.page : ""}`
          )
          .then(x => x.data)
          .catch(error => {});
        console.log(a);
        resolve(a);
      });
    },
    searchResource({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          function(config) {
            let token = state.access_token;
            if (token) {
              config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
          },
          function(error) {
            return Promise.reject(error);
          }
        );
        axios.interceptors.response.use(
          async response => {
            return response;
          },
          async error => {
            if (error.response.status === 401) {
              // await dispatch('goOffline')
              commit("unAuthLogout");
            }
            return error;
          }
        );
        let a = await axios
          .post(`${state.settings.apiBase}${payload.resource}${payload.page ? payload.page : ""}`, {
            value: payload.value
          })
          .then(x => x.data)
          .catch(error => {});
        console.log(a);
        resolve(a);
      });
    },
    putResource({ commit, dispatch, state }, payload) {
      return new Promise((resolve, reject) => {
        customAxios
          .put(payload.resource, { ...payload.value })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    deleteResource({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          function(config) {
            let token = state.access_token;
            if (token) {
              config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
          },
          function(error) {
            return Promise.reject(error);
          }
        );
        axios.interceptors.response.use(
          async response => {
            return response;
          },
          async error => {
            if (error.response.status === 401) {
              // await dispatch('goOffline')
              commit("unAuthLogout");
            }
            return error;
          }
        );
        let a = await axios
          .delete(`${state.settings.apiBase}${payload.resource}`)
          .then(x => x.data)
          .catch(error => {});
        console.log(a);
        resolve(a);
      });
    },
    fethOAuthRedirectURL({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        const response = await axios.get(`${state.settings.apiBase}/auth/${payload.provider}/redirect`);
        resolve(response.data.url);
      });
    },
    loginWithSocialToken({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        const setCookie = (name, value, days) => {
          var expires = "";
          var maxAge = "";
          if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
            maxAge = "; max-age=" + date.toUTCString();
          }
          document.cookie = name + "=" + (value || "") + expires + "; path=/";
        }

        try {
          console.log('Processing social login with params:', payload);

          // Call your API endpoint that handles social auth token validation
          // Pass all received parameters to the backend
          const response = await axios.get(`${state.settings.apiBase}/auth/${payload.provider}/callback`, {
            params: payload.params
          });

          if (response && response.data && response.data.access_token) {
            this.loading = false
            this.state.centralLogin = true
            this.state.access_token = response.data.access_token
            setCookie('_MJC', response.data.access_token, 1)
            this.state.user = response.data.user

            resolve(response.data.user);
          } else {
            console.error('Invalid response from social auth endpoint');
            reject(new Error('Authentication failed'));
          }
        } catch (error) {
          console.error('Social auth error:', error);
          reject(error);
        }
      });
    },
    loadSettings({ commit, dispatch, state }, payload) {
      return new Promise(async (res, rej) => {
        //// AUTH SET CHECK ///
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          function(config) {
            let token = state.access_token;
            if (token) {
              config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
          },
          function(error) {
            return Promise.reject(error);
          }
        );
        axios.interceptors.response.use(
          async response => {
            return response;
          },
          async error => {
            if (error.response.status === 401) {
              // await dispatch('goOffline')
              commit("unAuthLogout");
            }
            return error;
          }
        );
        //// AUTH SET CHECK ///
        // commit('updateSettings', settings)
        res(true);
      });
    }
  },
  getters: {}
});
